export default "__VITE_PUBLIC_ASSET__e8abdc0d__"